export default __webpack_public_path__ + "static/media/background_register.3b8d0afa.jpg";